const firebaseConfig = {
  apiKey: "AIzaSyBAkJjL7CvGBOVxYWvtr0FstkfL1lTI348",
  authDomain: "leads-produxia.firebaseapp.com",
  projectId: "leads-produxia",
  storageBucket: "leads-produxia.firebasestorage.app",
  messagingSenderId: "307108892218",
  appId: "1:307108892218:web:40181d56b711b85627ef03"
};
firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();

const db   = firebase.firestore();
const FieldValue = firebase.firestore.FieldValue;

/**
 * Chama uma função do servidor. Usada onde a regra do Firestore não basta:
 * mexer em `users` precisa de alguém CONFERINDO quem pede, e isso só existe
 * do lado de lá. A região tem que ser a mesma do deploy, senão dá 404.
 */
function chamar(nome) {
  // Preguiçoso de propósito: resolver a função na importação amarraria o
  // módulo ao SDK já carregado, e aí a tela quebra em teste e em qualquer
  // caminho que importe antes do Firebase subir.
  return (dados) => firebase.app().functions('southamerica-east1')
    .httpsCallable(nome)(dados).then(r => r.data);
}

// ─── Verificação de acesso via Firestore ─────────────────────
// Devolve null só quando o acesso NÃO existe (doc ausente ou inativo).
// Falha de leitura (rede, extensão bloqueando o Firestore, sessão velha) volta
// como { erro }, para o app não confundir "não consegui ler" com "não tem acesso".
async function getUserDoc(email, tentativa = 1) {
  try {
    const doc = await db.collection('users').doc(email).get({ source: 'server' });
    if (!doc.exists || !doc.data().active) return null;
    const data = doc.data();
    return {
      email,
      role:            data.role            || 'viewer',
      companies:       data.companies       || ['produxia'],
      admin_companies: data.admin_companies || null, // lista de empresas onde é admin (sobrescreve role)
      active:          data.active          || false,
    };
  } catch(e) {
    console.error('[acesso] falha ao ler users/' + email, e);
    if (tentativa < 3) {
      await new Promise(r => setTimeout(r, 700 * tentativa));
      return getUserDoc(email, tentativa + 1);
    }
    return { erro: e.code || e.message || 'desconhecido' };
  }
}


// ─── Constantes ───────────────────────────────────────────

export { auth, chamar, db, FieldValue, firebaseConfig, getUserDoc };
